import { PayloadRequest } from 'types/requestTypes';

import { omdApi } from '../api';
import {
  NomenclatureTransfer,
  NomenclatureTransferCreate,
  NomenclatureTransferDetail,
  NomenclatureTransferStatus,
} from './types';

const request = omdApi.injectEndpoints({
  endpoints: (builder) => ({
    getNomenclatureTransferDetail: builder.query<NomenclatureTransfer, PayloadRequest>({
      query: (data) => ({
        url: `/v1/NomenclatureTransfer/${data.id}`,
      }),
      providesTags: ['NomenclatureTransfer'],
    }),
    changeNomenclatureTransfer: builder.mutation<void, NomenclatureTransfer>({
      query: (data) => ({
        url: `/v1/NomenclatureTransfer/${data.id}`,
        method: 'PUT',
        body: data,
      }),
      invalidatesTags: ['NomenclatureTransfer'],
    }),
    createNomenclatureTransfer: builder.mutation<void, NomenclatureTransferCreate>({
      query: (data) => ({
        url: '/v1/NomenclatureTransfer',
        method: 'POST',
        body: data,
      }),
    }),
    deleteNomenclatureTransfer: builder.mutation<void, PayloadRequest>({
      query: (data) => ({
        url: `/v1/NomenclatureTransfer/${data.id}`,
        method: 'DELETE',
      }),
    }),
    changeNomenclatureTransferStatus: builder.mutation<void, NomenclatureTransferStatus>({
      query: (data) => ({
        url: `/v1/NomenclatureTransfer/${data.id}/status`,
        method: 'PUT',
        body: data,
      }),
      invalidatesTags: ['NomenclatureTransfer'],
    }),

    getNomenclatureTransferTransportDetail: builder.query<NomenclatureTransferDetail, PayloadRequest>({
      query: ({ id }) => ({
        url: `/v1/NomenclatureTransfer/details/${id}`,
      }),
    }),
    nomenclatureTransferTransportChange: builder.mutation<void, NomenclatureTransferDetail>({
      query: (data) => ({
        url: `/v1/NomenclatureTransfer/details/${data.id}`,
        method: 'PUT',
        body: data,
      }),
    }),
    nomenclatureTransferTransportDelete: builder.mutation<void, PayloadRequest>({
      query: (data) => ({
        url: `/v1/NomenclatureTransfer/details/${data.id}`,
        method: 'DELETE',
        body: data,
      }),
    }),
    nomenclatureTransferTransportCreate: builder.mutation<void, NomenclatureTransferDetail>({
      query: (data) => ({
        url: `/v1/NomenclatureTransfer/${data.nomenclatureTransferId}/details`,
        method: 'POST',
        body: data,
      }),
    }),
  }),
});

export const {
  useChangeNomenclatureTransferMutation,
  useChangeNomenclatureTransferStatusMutation,
  useCreateNomenclatureTransferMutation,
  useDeleteNomenclatureTransferMutation,
  useGetNomenclatureTransferDetailQuery,
  useLazyGetNomenclatureTransferDetailQuery,

  useNomenclatureTransferTransportChangeMutation,
  useGetNomenclatureTransferTransportDetailQuery,
  useLazyGetNomenclatureTransferTransportDetailQuery,
  useNomenclatureTransferTransportCreateMutation,
  useNomenclatureTransferTransportDeleteMutation,
} = request;
